import { ColumnType, DateFormat, TimeFormat } from "../types/table-type";
import { DimensionColumnPriority } from "../types/form-type";

// 后端 rollup number 拼接用字符串
export const ROLLUP_NUMBER_SPLIT_KEY = ", ";

// format 所用icon
export const TABLE_CELL_VALUE_ICON_PENTAGRAM = "★";
export const TABLE_CELL_VALUE_ICON_CHECKED = "✓";
export const TABLE_CELL_VALUE_ICON_UNCHECKED = "▢";

// 维度轴 允许的 column 类型
export const DIMENSION_COLUMN_TYPE: { [key in ColumnType]?: DimensionColumnPriority } = {
  [ColumnType.TEXT]: DimensionColumnPriority.OTHER,
  [ColumnType.STATUS]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.SELECT]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.MULTI_SELECT]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.COLLABORATOR]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.DATETIME]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.NUMBER]: DimensionColumnPriority.OTHER,
  [ColumnType.CURRENCY]: DimensionColumnPriority.OTHER,
  [ColumnType.RATING]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.CHECKBOX]: DimensionColumnPriority.OTHER,
  [ColumnType.PHONE]: DimensionColumnPriority.OTHER,
  [ColumnType.EMAIL]: DimensionColumnPriority.OTHER,
  [ColumnType.RECORD_REFERENCE]: DimensionColumnPriority.OTHER,
  [ColumnType.CREATED_AT]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.CREATED_BY]: DimensionColumnPriority.RECOMMEND,
};

export const SUMMARY_VALUE_COLUMN_PRIORITY_TYPE: { [key in ColumnType]?: DimensionColumnPriority } = {
  [ColumnType.NUMBER]: DimensionColumnPriority.RECOMMEND,
  [ColumnType.CURRENCY]: DimensionColumnPriority.RECOMMEND,
};

// value 轴 允许的 column 类型
export const VALUE_COLUMN_TYPE: { [key in ColumnType]?: boolean } = {
  [ColumnType.NUMBER]: true,
  [ColumnType.CURRENCY]: true,
  [ColumnType.RATING]: true,
};

export const DATE_FORMAT_MAP_EN = {
  [DateFormat.SLASH]: "YYYY/MM/DD",
  [DateFormat.LOCAL]: "MM/DD/YYYY",
  [DateFormat.FRIENDLY]: "MMM do,YYYY",
  [DateFormat.ISO]: "YYYY-MM-DD",
};

export const DATE_FORMAT_MAP_ZH = {
  [DateFormat.SLASH]: "YYYY/MM/DD",
  [DateFormat.LOCAL]: "MM/DD/YYYY",
  [DateFormat.FRIENDLY]: "YYYY年MM月DD日",
  [DateFormat.ISO]: "YYYY-MM-DD",
};

export const TIME_FORMAT_MAP_EN = {
  [TimeFormat.TWELVE_HOUR]: "hh:mm pm",
  [TimeFormat.TWOFOUR_HOUR]: "hh:mm",
};

export const TIME_FORMAT_MAP_ZH = TIME_FORMAT_MAP_EN;

// 在将数据提供给 echart 之前 对 dimensions group 进行 format
// 值为数组的列 都满足该条件 所以需要求原始类型
// 在转化时 记录 dimensions group 是否进行过该操作 然后 适时的设置 对应 format 函数为 (value) => value
// format 时 数组内元素相同 顺序不同 视为同一个
export const ADVANCE_FORMAT_COLUMN: { [key in ColumnType]?: boolean } = {
  [ColumnType.MULTI_SELECT]: true,
  [ColumnType.RECORD_REFERENCE]: true,
  [ColumnType.COLLABORATOR]: true,
  [ColumnType.CREATED_BY]: true,
};

// 判断该列的 value 是否可以直接用于展示
// 若 value 需要结合其他数据才能展示 return true
export const checkReferenceColumn: { [key in ColumnType]?: true } = {
  [ColumnType.COLLABORATOR]: true,
  [ColumnType.STATUS]: true,
  [ColumnType.SELECT]: true,
  [ColumnType.MULTI_SELECT]: true,
  [ColumnType.RECORD_REFERENCE]: true,
  [ColumnType.CREATED_BY]: true,
};

// 公式类型 具有 format 必要时 逆向解析才能参与计算
export const IS_FORMULA_COLUMN_TYPE: { [key in ColumnType]?: true } = {
  [ColumnType.FORMULA]: true,
  [ColumnType.ROLLUP]: true,
};

// 是 number 类型的 column
export const IS_NUMBER_TYPE_COLUMN: { [key in ColumnType]?: true } = {
  [ColumnType.NUMBER]: true,
  [ColumnType.RATING]: true,
  [ColumnType.CURRENCY]: true,
};

/** 判断 columnType 的 option 是否包含 color 字段 */
export const HAS_COLOR_BY_OPTION: Record<ColumnType, boolean> = {
  [ColumnType.MULTI_SELECT]: true,
  [ColumnType.SELECT]: true,
  [ColumnType.STATUS]: true,
  [ColumnType.TEXT]: false,
  [ColumnType.LONG_TEXT]: false,
  [ColumnType.MULTI_ATTACHMENT]: false,
  [ColumnType.PHONE]: false,
  [ColumnType.EMAIL]: false,
  [ColumnType.LOOKUP]: true,
  [ColumnType.RECORD_REFERENCE]: false,
  [ColumnType.AUTO_NUMBER]: false,
  [ColumnType.CREATED_AT]: false,
  [ColumnType.CREATED_BY]: false,
  [ColumnType.CHECKBOX]: false,
  [ColumnType.COLLABORATOR]: false,
  [ColumnType.CURRENCY]: false,
  [ColumnType.DATETIME]: false,
  [ColumnType.FORMULA]: false,
  [ColumnType.ROLLUP]: false,
  [ColumnType.NOOP]: false,
  [ColumnType.NUMBER]: false,
  [ColumnType.RATING]: false,
  [ColumnType.UNIQUE_ID]: false,
};
